import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, FormControl, Grid, Paper, Typography } from '@mui/material';
import moment from 'moment';
import { fetchSiteLeaderboardsIfNeeded } from '../../../actions/sites';
import DateAndGranularityPicker, {
  dateRangeOptionsList,
} from '../../../components/DateAndGranularityPicker/DateAndGranularityPicker';
import useActiveSite from '../../../hooks/useActiveSite';
import LeaderboardsTables from '../../../components/LeaderboardsTables';

const SCDashboardLeaderboards = () => {
  const leaderboards = useSelector(state => state.entities.sites.leaderboards);
  const activeSite = useActiveSite();
  const dispatch = useDispatch();

  const showLoading = leaderboards.inflight;

  const onDateAndGranularityPickerChange = ({ dateRange }) => {
    const _dateRange = !dateRange
      ? null
      : {
          startDate: moment(dateRange.startDate).format('YYYYMMDD'),
          endDate: moment(dateRange.endDate).format('YYYYMMDD'),
        };
    dispatch(fetchSiteLeaderboardsIfNeeded(activeSite.id, _dateRange));
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Box mb={2}>
            <Typography variant="h6" color="textSecondary">
              Leaderboards
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Paper sx={{ margin: `8px auto`, padding: 2 }}>
            <FormControl variant="standard" component="fieldset">
              <DateAndGranularityPicker
                showAllDateRange
                defaultDateRange={dateRangeOptionsList.thisQTD.value}
                dateRangeOptions={{
                  lastWeek: dateRangeOptionsList.lastWeek,
                  last7Days: dateRangeOptionsList.last7Days,
                  last90Days: dateRangeOptionsList.last90Days,
                  today: dateRangeOptionsList.today,
                  thisMTD: dateRangeOptionsList.thisMTD,
                  thisQTD: dateRangeOptionsList.thisQTD,
                  thisYTD: dateRangeOptionsList.thisYTD,
                }}
                customDateRangeOptions={{
                  maxDate: new Date(),
                }}
                showCustomDateRange
                showGranularity={false}
                isDisabled={showLoading}
                onChange={onDateAndGranularityPickerChange}
              />
            </FormControl>
          </Paper>
        </Grid>
      </Grid>
      <LeaderboardsTables inflight={showLoading} data={leaderboards} />
    </>
  );
};

export default SCDashboardLeaderboards;
